import AuthLayout from "../../containers/auth";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import b from "../../assets/b.svg";
import lock from "../../assets/lock.svg";

const ResetPass = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isResetting, setIsResetting] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const resetEmail = localStorage.getItem("resetEmail");

    if (!resetEmail) {
      navigate("/auth/forgot-password");
    }

    setEmail(resetEmail);
  }, [navigate])

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error("Password and confirm password are required");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setIsResetting(true);
    try {
      const response = await api.post("/auth/reset-password", { email, password });

      if (response.status === 200) {
        toast.success(response.data.message);
        navigate("/auth/signin");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    } finally {
      setIsResetting(false);
    }
  }

  return (
    <AuthLayout imageSrc={b}>
      <h2 className="mb-2 text-2xl   font-bold text-secondary text-center">
      New Password, New Wins! 
      –{" "}
        <span className="block">Let’s Do This.
        </span>
      </h2>

      <p className="mb-6 text-sm text-gray-600 text-center">
        Enter your email address and we will send you a verification code to
        reset your password.
      </p>
      <form className="w-full max-w-sm">
       
      <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
          <img src={lock} alt="lock-icon"></img>
          <input
            type="password"
            placeholder="New Password"
            className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="mb-4 flex items-center rounded-2xl border border-gray-300 px-4 py-2">
          <img src={lock} alt="lock-icon"></img>
          <input
            type="password"
            placeholder="Confirm New Password"
            className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <button 
          className="w-full rounded-2xl bg-primary text-white py-3 font-bold hover:bg-opacity-90"
          onClick={handleResetPassword}
          disabled={isResetting}
        >
          {isResetting ? "Resetting..." : "Reset Password"}
        </button>

        <p className="mt-4 text-center text-sm text-gray-600">
          <Link to="/auth/signin" className=" text-secondary hover:underline">
            Back to Log in
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
};

export default ResetPass;
